import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnmParams } from 'APIPackage/KnmModule/interfaces/IKnmParams';
import { IKnmApproveDoc248 } from 'APIPackage/KnmModule/interfaces/IKnmApproveDoc248';
import { IKnmString } from 'APIPackage/KnmModule/interfaces/IKnmString';
import { IKnmPlanReason } from 'APIPackage/KnmModule/interfaces/IKnmPlanReason';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { convertCollaboratingOrganizationsFormValueToKnmData } from 'KnmPackage/MainModule/common/convertCollaboratingOrganizationsFormValueToKnmData';
import { getIntNumberByString } from 'CorePackage/MainModule/common/getIntNumberByString';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { createKnmErknmStaticData } from './createKnmErknmStaticData';
import { convertDecisionFormValuesToKnmData } from './convertDecisionFormValuesToKnmData';
import { convertReasonsFormValueToKnmData } from './convertReasonsFormValueToKnmData';
import { convertReasonDocumentsFormValueToKnmData } from './convertReasonDocumentsFormValueToKnmData';
import { convertApproveFormValuesToKnmData } from './convertApproveFormValuesToKnmData';
import { convertEventsFormValuesToKnmData } from './convertEventsFormValuesToKnmData';
import { convertOrganizationsFormValuesToKnmData } from './convertOrganizationsFormValuesToKnmData';
import { convertObjectsFormValueToKnmData } from './convertObjectsFormValueToKnmData';
import { convertInspectorsFormValuesToKnmDataOld } from './convertInspectorsFormValuesToKnmDataOld';
import { convertExpertsFormValueToKnmData } from './convertExpertsFormValueToKnmData';
import { convertDocumentsFormValueToKnmData } from './convertDocumentsFormValueToKnmData';
import { convertServiceDocumentFormValuesToKnmData } from './convertServiceDocumentFormValuesToKnmData';
import { convertChecklistsFormValueToKnmData } from './convertChecklistsFormValueToKnmData';
import { convertManuallyChecklistsFormValueToKnmData } from './convertManuallyChecklistsFormValueToKnmData';
import { convertRequirementsFormValueToKnmData } from './convertRequirementsFormValueToKnmData';
import { convertManuallyRequirementsFormValueToKnmData } from './convertManuallyRequirementsFormValueToKnmData';
import { convertRequirementsNpaFormValueToKnmData } from './convertRequirementsNpaFormValueToKnmData';
import { convertJudgmentsFormValuesToKnmData } from './convertJudgmentsFormValuesToKnmData';
import { IKnmSubjectNotification } from '../../../APIPackage/KnmModule/interfaces/IKnmSubjectNotification';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { SYSTEM_DATE_FORMAT_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';
import { convertFormDateTimeValueToKnmDataDate } from '../../../KnmPackage/MainModule/common/convertFormDateTimeValueToKnmDataDate';
import { convertFormTimeValueToKnmDataTime } from '../../../KnmPackage/MainModule/common/convertFormTimeValueToKnmDataTime';
import { KnmErknmStatusCodesEnum } from '../../../APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';
import { convertAgreementsFormValuesToData } from './convertAgreementsFormValuesToData';
import { convertApprovedOnPaperDocumentsFormValueToKnmData } from './convertApprovedOnPaperDocumentsFormValueToKnmData';
import { convertApproveChangePlanFormValuesToKnmData } from './convertApproveChangePlanFormValuesToKnmData';

export const convertKnmErknmFormValuesToCreateParams = (
  values: IKnmErknmForm,
  knmData?: IKnm,
  _isNeededGetDocumentsFromKnmData?: boolean,
  isDraft?: boolean,
) => {
  const {
    knoOrganizationErknm,
    startDate,
    stopDate,
    durationDays,
    durationHours,
    directDurationDays,
    kindControl,
    kindKnm,
    typeErknm,
    planId,
    planGuid,
    dataContent,
    prosecutorOrganizationErknm,
    documents,
    places,
    organizationDocuments,
    approveDocs,
    docTarget,
    isChecklistsUsed,
    documentRequestDate,
    documentResponseDate,
    returnSelection,
    isSelection,
    selection,
    selectionReactQuillEditor,
    withVideo,
    isPresence,
    isPresenceDelegateFullNames,
    links,
    isRemote,
    interactionCategory,
    videoCallInfo,
    remoteNote,
    isHasCollaboratingOrganization,
    collaboratingOrganizationsErknm,
    appealStatus,
    changePlanReason,
    isAppealed,
    oldKnmNumber,
    oldPlanNumber,
    isCreatePlan,
    notNotifySubject: isNotNotifySubject,
    abrogation,
    rescheduling,
    created,
    startTime,
    stopTime,
    initialStopDate,
    isTest,
    completedRO: isCompletedRO,
    extractVersion,
    extractPerform,
    isApprovedOnPaper,
  } = values;
  const planIdNumber = Number(planId);
  const durationHoursNumber = durationHours && Number(durationHours.replace(',', '.'));

  const params: IKnmParams = {
    ...createKnmErknmStaticData(knmData),
    isTest: isTest ?? null,
    planId: typeof planIdNumber === 'number' && !Number.isNaN(planIdNumber) ? planIdNumber : null,
    planGuid: planGuid || null,
    createPlan: isCreatePlan || null,
    type: typeErknm || null,
    startDate: convertFormDateValueToKnmDataDate(startDate),
    startTime: convertFormTimeValueToKnmDataTime(startTime),
    stopDate: convertFormDateValueToKnmDataDate(stopDate),
    stopTime: convertFormTimeValueToKnmDataTime(stopTime),
    prosecutorOrganization: {
      id:
        !prosecutorOrganizationErknm?.ervkUuid && prosecutorOrganizationErknm?.id
          ? prosecutorOrganizationErknm?.id
          : null,
      code: null,
      name: prosecutorOrganizationErknm?.fullName || null,
      address: null,
      contacts: null,
      federalDistrictId: null,
      regionId: null,
      parentId: null,
      enabled: null,
      ervkUuid: prosecutorOrganizationErknm?.ervkUuid || knmData?.prosecutorOrganization?.ervkUuid,
      ervkVersionUuid: prosecutorOrganizationErknm?.ervkVersionUuid || knmData?.prosecutorOrganization?.ervkVersionUuid,
    },
    links:
      links?.map(formLink => ({
        guid: formLink.guid || null,
        erpId: formLink.erpId,
      })) || null,
    district: {
      id: prosecutorOrganizationErknm?.districtId || knmData?.district?.id || null,
      name: prosecutorOrganizationErknm?.districtName || knmData?.district?.name || null,
      center: null,
      okatoTer: null,
      okatoKod1: null,
      okatoRazdel: null,
      federalRegionCode: null,
      federalDistrict: null,
    },
    noticeMethod: null,
    noticeDate: null,
    documents: convertDocumentsFormValueToKnmData(documents, isTest, isDraft),
    knmErknm: {
      federalLawErvk: null,
      subjectTypeErvk: null,
      extractPerform: !extractPerform
        ? null
        : {
            active: extractPerform.active || null,
            attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(extractPerform.attachments),
            correlationToken: extractPerform.correlationToken || null,
            description: extractPerform.description || null,
            guid: extractPerform.guid || null,
            type: extractPerform.type || null,
          },
      extractVersion: extractVersion || null,
      completedRO: isCompletedRO || null,
      accessToken: knmData?.knmErknm?.accessToken || null,
      notNotifySubject: isNotNotifySubject || null,
      rescheduling: !rescheduling
        ? null
        : rescheduling.map(reschedule => {
            let differenceInDays: number = 0;

            if (reschedule?.newStartDate && reschedule?.newEndDate) {
              const dateStart = new Date(
                formatDate({ date: reschedule.newStartDate, dateFormat: SYSTEM_DATE_FORMAT_FNS }),
              );
              const dateEnd = new Date(formatDate({ date: reschedule.newEndDate, dateFormat: SYSTEM_DATE_FORMAT_FNS }));
              const differenceInTime = dateEnd.getTime() - dateStart.getTime();

              differenceInDays = differenceInTime / (1000 * 3600 * 24);
            }

            return {
              isNew: isDraft ? reschedule.isNew : null,
              oldStartDate: convertFormDateTimeValueToKnmDataDate(reschedule.oldStartDate, true) || null,
              oldEndDate: convertFormDateTimeValueToKnmDataDate(reschedule.oldEndDate, true) || null,
              newStartDate: convertFormDateTimeValueToKnmDataDate(reschedule.newStartDate, true) || null,
              newEndDate: convertFormDateTimeValueToKnmDataDate(reschedule.newEndDate, true) || null,
              initiationDate: convertFormDateTimeValueToKnmDataDate(reschedule.initiationDate, true) || null,
              newDirectDurationDays: reschedule.newDirectDurationDays || null,
              newDurationDays: differenceInDays + 1,
              newDurationHours: reschedule.newDurationHours || null,
              comment: reschedule.comment || null,
              guid: reschedule.guid || null,
            };
          }),
      abrogation: abrogation
        ? {
            comment: abrogation?.comment || undefined,
            reasonFile: abrogation?.reasonFile ? abrogation?.reasonFile[0] : undefined,
            link: abrogation?.link || undefined,
            reasonId: abrogation?.reasonId?.id.toString() || '',
          }
        : null,
      knoOrganization: knoOrganizationErknm?.value || null,
      decision: convertDecisionFormValuesToKnmData(values),
      durationDays: getIntNumberByString(durationDays),
      durationHours: typeof durationHoursNumber === 'number' ? durationHoursNumber : null,
      directDurationDays: directDurationDays ? Number(directDurationDays) || null : null,
      kindControl: kindControl?.value || null,
      kindKnm: kindKnm?.value || null,
      reasonDocuments: convertReasonDocumentsFormValueToKnmData(values),
      reasons: convertReasonsFormValueToKnmData(values?.reasonsErknm),
      dataContent: dataContent || null,
      prosecutorDocuments: null,
      approve: convertApproveFormValuesToKnmData(values, knmData),
      organizations: convertOrganizationsFormValuesToKnmData(values, created, isDraft),
      judgments: convertJudgmentsFormValuesToKnmData(values, isDraft),
      objects: convertObjectsFormValueToKnmData(values.objectsErknm, !knmData, isDraft),
      inspectors: convertInspectorsFormValuesToKnmDataOld(values.inspectorsErknm),
      experts: convertExpertsFormValueToKnmData(values.experts),
      isHasCollaboratingOrganization:
        typeof isHasCollaboratingOrganization === 'boolean' ? isHasCollaboratingOrganization : null,
      collaboratingOrganizations: convertCollaboratingOrganizationsFormValueToKnmData(collaboratingOrganizationsErknm),
      events: convertEventsFormValuesToKnmData(values.eventsErknm, values.suspensionEvents, undefined, isDraft),
      collaboratingOrganizationChangeDate: null,
      requirements: convertRequirementsFormValueToKnmData(values),
      requirementsNew: convertRequirementsNpaFormValueToKnmData(values),
      approveDocs:
        approveDocs?.map(item => {
          const knmDataApproveDoc: IKnmApproveDoc248 = {
            approveDoc: item.approveDoc?.value || null,
            dateCreate: item.dateCreate || null,
            numGuid: item.numGuid || null,
          };

          return knmDataApproveDoc;
        }) || null,
      docTarget:
        docTarget?.map(doc => ({
          ervkControlKindDocTarget: doc.ervkControlKindDocTarget || null,
          specificRequirementAndClause: doc.specificRequirementAndClause || null,
          inspectionResult: doc.inspectionResult || null,
          file: doc.file?.length ? doc.file[0] : null,
          guid: doc.guid,
        })) || null,
      isChecklistsUsed: typeof isChecklistsUsed === 'boolean' ? isChecklistsUsed : null,
      checklists: convertChecklistsFormValueToKnmData(values, isDraft),
      places:
        places?.map(item => {
          return {
            value: item.value || null,
            guid: item.guid || null,
            dateCreate: item.dateCreate || null,
            manualAddress: item.manualAddress || null,
            matchesObjectAddress: item.matchesObjectAddress || null,
            notInFIAS: item.notInFIAS || null,
            region: item.region?.id?.toString() || null,
            fiasRegion: item.fiasRegion?.id?.toString() || null,
            regionName: item.regionName || null,
          };
        }) || null,
      organizationDocuments:
        organizationDocuments?.map(item => {
          const organizationDocument: IKnmString = {
            value: item.value || null,
            guid: item.guid || null,
            dateCreate: item.dateCreate || null,
          };

          return organizationDocument;
        }) || null,
      serviceDocument: convertServiceDocumentFormValuesToKnmData(values),
      isRemote: typeof isRemote?.value === 'boolean' ? isRemote.value : null,
      interactionCategory: interactionCategory || null,
      videoCallInfo:
        videoCallInfo?.map(i => {
          const dateTime = convertFormDateTimeValueToKnmDataDate(i.dateTime) || '';

          return {
            isNew: isDraft ? i.isNew : undefined,
            link: i.link,
            instruction: i.instruction || '',
            dateTime,
            guid: i.guid,
          };
        }) || null,
      noteRemote: remoteNote || null,
      withVideo: typeof withVideo?.value === 'boolean' ? withVideo.value : null,
      isSelection: typeof isSelection?.value === 'boolean' ? isSelection.value : null,
      selection: selection || null,
      selectionReactQuillEditor: handleReactQuillDeltaValue(selectionReactQuillEditor || selection),
      isPresence: typeof isPresence?.value === 'boolean' ? isPresence.value : null,
      isPresenceDelegateFullNames:
        isPresenceDelegateFullNames?.map(item => ({
          value: item.value || null,
          guid: item.guid || null,
          dateCreate: null,
        })) || null,
      returnSelection: typeof returnSelection?.value === 'boolean' ? returnSelection.value : null,
      attachmentsWeb: knmData?.knmErknm?.attachmentsWeb || null,
      documentRequestDate: convertFormDateValueToKnmDataDate(documentRequestDate),
      documentResponseDate: convertFormDateValueToKnmDataDate(documentResponseDate),
      manuallyRequirements: convertManuallyRequirementsFormValueToKnmData(values),
      manuallyCheckList: convertManuallyChecklistsFormValueToKnmData(values),
      appealStatus: appealStatus?.value || null,
      changePlanReason:
        changePlanReason?.map(item => {
          const changePlanReasonItem: IKnmPlanReason = {
            code: item.code || null,
            reasonChangeType: item.reasonChangeType || null,
            guid: item.guid || null,
            dateCreate: item.dateCreate || null,
            approve: convertApproveChangePlanFormValuesToKnmData(
              item,
              knmData?.knmErknm?.changePlanReason?.filter((reason: IKnmPlanReason) => {
                return reason.guid === item.guid;
              }),
            ),
          };

          return changePlanReasonItem;
        }) || null,
      changePlanChanges: {
        objects: knmData?.knmErknm?.objects || null,
      },
      isAppealed: typeof isAppealed === 'boolean' ? isAppealed : null,
      oldKnmNumber: oldKnmNumber || null,
      oldPlanNumber: oldPlanNumber || null,
      webNotificationInfos: knmData?.knmErknm?.webNotificationInfos || null,
      accessPrivilege: null,
      untimelyBasic: knmData?.knmErknm?.untimelyBasic || null,
      initialStopDate:
        initialStopDate && knmData?.status?.code !== KnmErknmStatusCodesEnum.COMMENTS_EXIST
          ? knmData?.knmErknm?.initialStopDate || null
          : convertFormDateValueToKnmDataDate(stopDate),
      ervkCorrectionRequired: knmData?.knmErknm?.ervkCorrectionRequired || null,
      firstExtractDateTime: knmData?.knmErknm?.firstExtractDateTime || null,
      agreements: convertAgreementsFormValuesToData(values.agreements),
      agreementOnApproval: values.agreementOnApproval || null,
      repeatPassports: values.repeatPassports || null,
      subjectsTypeChangeOptionAvailable: knmData?.knmErknm?.subjectsTypeChangeOptionAvailable || null,

      isApprovedOnPaper: typeof isApprovedOnPaper === 'boolean' ? isApprovedOnPaper : null,
      approvedOnPaperDocuments: convertApprovedOnPaperDocumentsFormValueToKnmData(values),
    },
    version: KnmVersionsEnum.ERKNM,
    subjectNotifications:
      values?.subjectNotifications?.map(x => {
        const notification: IKnmSubjectNotification = {
          date: convertFormDateValueToKnmDataDate(x.date),
          type: x.type || null,
          comment: x.comment || null,
          commentReactQuillEditor: null, // x.commentReactQuillEditor || null,
          guid: x.listId,
          isNew: isDraft ? x.isNew : null,
        };

        return notification;
      }) || null,
    knmCopyInvalidFields: [],
    reasonChangeKno: knmData?.reasonChangeKno || null,
    dateReasonChangeKno: knmData?.dateReasonChangeKno || null,
    oldKnoOrganization: knmData?.oldKnoOrganization || null,
    reasonChangeControllingSubject: knmData?.reasonChangeControllingSubject || null,
    dateReasonChangeControllingSubject: knmData?.dateReasonChangeControllingSubject || null,
    oldNameControllingSubject: knmData?.oldNameControllingSubject,
  };

  return params;
};
